import {
    getIsBrowserSupportingAllClassroomFeatures,
    getWellSupportedBrowserName,
    isBrowserOutdated,
} from './platform';

export const getBrowserSupportsNewClassroomStatusByUserRole = (userRole: 'student' | 'teacher') => {
    const browserName = getWellSupportedBrowserName();

    if (userRole === 'teacher') {
        return {
            wellSupportedBrowserName: browserName,
            browserSupportStatus: getIsBrowserSupportingAllClassroomFeatures()
                ? 'supported'
                : 'not-supported',
        } as const;
    }

    if (browserName) {
        const isBrowserOutdatedResult = isBrowserOutdated(browserName);
        if (isBrowserOutdatedResult === null) {
            return {
                wellSupportedBrowserName: browserName,
                browserSupportStatus: 'not-supported',
            } as const;
        }

        return {
            wellSupportedBrowserName: browserName,
            browserSupportStatus: isBrowserOutdatedResult ? 'outdated' : 'supported',
        } as const;
    }

    return {
        wellSupportedBrowserName: null,
        browserSupportStatus: 'not-supported',
    } as const;
};
